import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import "./fonts/fonts.css";
import "./GlobalStyle";
import "flatpickr/dist/themes/material_green.css";
import { initSentry } from "./Sentry";
import { setLangugeAndDir } from "./SetLanguageAndFont";
import "./i18n";

initSentry();
setLangugeAndDir();
// ReactGA.initialize("G-KFNB919X4D", {
//   testMode: process.env.NODE_ENV !== "production",
// });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
  {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn("Uncaught error", error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  },
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
